// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ProposalSource } from './proposalSource.zod.ts';

export const ProposedCountry = zod.object({
  "code": zod.string(),
  "source": ProposalSource
});

export type ProposedCountry = zod.input<typeof ProposedCountry>;
export type ProposedCountryOutput = zod.output<typeof ProposedCountry>;
